import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { HRM1060_R01Dto } from './Dto_HRM1060_R01';
import { HRM1060_R01Filter } from './Store_HRM1060_R01';

/** HRM1060의 API 기본 주소이다. */
const baseUrl = `${config.apiUrl}/HRM1060_R01`;

/** 조건에 맞는 대장을 조회한다. @param option search 또는 refetch @param params 필터 @param listLength 현재 길이 @returns 목록 응답 */
export const getHRM1060_R01List = (option: string, params: Partial<HRM1060_R01Filter>, listLength = 0) =>
    getData<ResponseDto<HRM1060_R01Dto[]>>(`${baseUrl}/${option}`, { params: { ...params, listLength } });

/** 전체 건수를 조회한다. @param params 필터 @returns 건수 응답 */
export const getHRM1060_R01AllCount = (params: Partial<HRM1060_R01Filter>) =>
    getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: { ...params } });

/** 신규 행을 등록한다. @param data 신규 목록 @returns 저장 결과 */
export const postHRM1060_R01 = (data: HRM1060_R01Dto[]) =>
    postData<HRM1060_R01Dto[], ResponseDto<HRM1060_R01Dto[]>>(baseUrl, data);

/** 기존 행을 수정한다. @param data 수정 목록 @returns 저장 결과 */
export const patchHRM1060_R01 = (data: HRM1060_R01Dto[]) =>
    patchData<HRM1060_R01Dto[], ResponseDto<HRM1060_R01Dto[]>>(baseUrl, data);

/** 쉼표 구분 번호를 인코딩해 삭제한다. @param certNo 발급번호 @returns 삭제 결과 */
export const deleteHRM1060_R01 = (certNo: string) =>
    deleteData<ResponseDto<void>>(`${baseUrl}/${encodeURIComponent(certNo)}`);

/** 대장을 XLSX로 내려받는다. @param option 검색 방식 @param params 필터 @param listLength 목록 길이 @returns Base64 응답 */
export const downloadExcel_HRM1060_R01 = (option: string, params: Partial<HRM1060_R01Filter>, listLength = 0) =>
    getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, { params: { ...params, listLength } });

/** 출력 요청을 한 번 기록한다. @param certNo 발급번호 @returns 갱신된 대장 행 */
export const patchHRM1060_R01Print = (certNo: string) =>
    patchData<undefined, ResponseDto<HRM1060_R01Dto>>(`${baseUrl}/print/${encodeURIComponent(certNo)}`, undefined);

/** 데이터 변경 없이 PDF Blob을 받는다. @param certNo 발급번호 @returns PDF Blob */
export const getPdfBlob_HRM1060_R01 = async (certNo: string): Promise<Blob> => {
    const response = await getData<Blob>(`${baseUrl}/pdf/${encodeURIComponent(certNo)}`, { responseType: 'blob' });
    return new Blob([response.data], { type: 'application/pdf' });
};
